import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReporteProduccion from "../../paginas/Reportes/Reportes.jsx";
import VentasReportes from "../../paginas/Reportes/VentasReportes.jsx";
import Comprobantes from "../../paginas/Comprobantes/Comprobantes.jsx";
import CuentaCorriente from "../../paginas/CuentaCorriente/CuentaCorriente.jsx";
import NotasCredito from "../../paginas/NotasCredito/NotasCredito.jsx";
import CajaReporte from "../../paginas/Reportes/CajaReporte.jsx";
import IngresosReportes from "../IngresosReportes/IngresosReportes.jsx";
import DespachoReportes from "../DespachosReportes/DespachosReportes.jsx";
import StockReportes from "../StockReportes/StockReportes.jsx";
import Trazabilidad from "../Trazabilidad/Trazabilidad.jsx";
import { PERMISOS, puedeAcceder } from "../../servicios/sesionSeguridad";
import "./navReportes.css";

const CATEGORIAS = [
  { id: "comercial", nombre: "Comercial", icono: "pi-chart-line", reportes: [
    { id: "ventas", nombre: "Ventas", descripcion: "Resumen, detalle, ranking y estados.", icono: "pi-shopping-cart", Componente: VentasReportes, permisos: [PERMISOS.REPORTES_VER, PERMISOS.REPORTES_VENTAS_VER] },
    { id: "comprobantes", nombre: "Comprobantes", descripcion: "Facturas y documentación emitida.", icono: "pi-file", Componente: Comprobantes, permiso: PERMISOS.COMPROBANTES_VER },
    { id: "cuenta-clientes", nombre: "Ventas por cliente", descripcion: "Ventas realizadas a un cliente.", icono: "pi-shopping-cart", Componente: CuentaCorriente, permiso: PERMISOS.CUENTA_CORRIENTE_VER },
    { id: "notas-credito", nombre: "Notas de crédito", descripcion: "Consulta y acreditaciones asociadas.", icono: "pi-replay", Componente: NotasCredito, permiso: PERMISOS.NOTAS_CREDITO_VER },
  ] },
  { id: "operacion", nombre: "Operación", icono: "pi-building", reportes: [
    { id: "ingresos", nombre: "Ingresos a planta", descripcion: "Mercadería recibida en el período.", icono: "pi-sign-in", Componente: IngresosReportes, permisos: [PERMISOS.REPORTES_VER, PERMISOS.REPORTES_INGRESOS_VER] },
    { id: "produccion", nombre: "Producción", descripcion: "Entradas y salidas del proceso.", icono: "pi-box", Componente: ReporteProduccion, permisos: [PERMISOS.REPORTES_VER, PERMISOS.REPORTES_PRODUCCION_VER] },
    { id: "despachos", nombre: "Despachos", descripcion: "Mercadería despachada y entregas.", icono: "pi-truck", Componente: DespachoReportes, permisos: [PERMISOS.REPORTES_VER, PERMISOS.REPORTES_DESPACHOS_VER] },
  ] },
  { id: "inventario", nombre: "Inventario y trazabilidad", icono: "pi-warehouse", reportes: [
    { id: "stock", nombre: "Stock", descripcion: "Existencias actuales y detalle exportable.", icono: "pi-warehouse", Componente: StockReportes, permisos: [PERMISOS.REPORTES_VER, PERMISOS.REPORTES_STOCK_VER] },
    { id: "trazabilidad", nombre: "Trazabilidad", descripcion: "Seguimiento por lote o producción.", icono: "pi-sitemap", Componente: Trazabilidad, permiso: PERMISOS.TRAZABILIDAD_VER },
  ] },
  { id: "caja", nombre: "Caja y cobros", icono: "pi-wallet", reportes: [
    { id: "movimientos", nombre: "Movimientos de caja", descripcion: "Totales, medios de pago e historial.", icono: "pi-wallet", Componente: CajaReporte, permisos: [PERMISOS.REPORTES_VER, PERMISOS.REPORTES_CAJA_VER] },
  ] },
];

export default function NavReportes() {
  const location = useLocation();
  const navigate = useNavigate();
  const [categoriaAbierta, setCategoriaAbierta] = useState(null);
  const [mostrarAyudaNavegacion, setMostrarAyudaNavegacion] = useState(() => typeof window === "undefined" || sessionStorage.getItem("reportes-tabs-ayuda-oculta") !== "1");
  const navegacionRef = useRef(null);
  const categorias = useMemo(() => CATEGORIAS
    .map((categoria) => ({
      ...categoria,
      reportes: categoria.reportes.filter((reporte) =>
        (reporte.permisos || [reporte.permiso]).some((permiso) => puedeAcceder(permiso))),
    }))
    .filter((categoria) => categoria.reportes.length), []);
  const disponibles = useMemo(() => categorias.flatMap((categoria) => categoria.reportes.map((reporte) => ({ ...reporte, categoriaId: categoria.id }))), [categorias]);
  const segmentos = location.pathname.split("/").filter(Boolean);
  const categoriaUrl = segmentos[1];
  const reporteUrl = segmentos[2];
  const reporteActual = disponibles.find((reporte) => reporte.categoriaId === categoriaUrl && reporte.id === reporteUrl) || disponibles[0];

  useEffect(() => {
    if (reporteActual && !disponibles.some((item) => item.categoriaId === categoriaUrl && item.id === reporteUrl)) {
      navigate(`/reportes/${reporteActual.categoriaId}/${reporteActual.id}`, { replace: true });
    }
  }, [categoriaUrl, disponibles, navigate, reporteActual, reporteUrl]);

  useEffect(() => {
    const cerrarMenu = (event) => {
      if (!navegacionRef.current?.contains(event.target)) setCategoriaAbierta(null);
    };
    const cerrarConEscape = (event) => {
      if (event.key === "Escape") setCategoriaAbierta(null);
    };
    document.addEventListener("pointerdown", cerrarMenu);
    document.addEventListener("keydown", cerrarConEscape);
    return () => {
      document.removeEventListener("pointerdown", cerrarMenu);
      document.removeEventListener("keydown", cerrarConEscape);
    };
  }, []);

  if (!reporteActual) return <main className="reportes-centro reportes-sin-acceso"><i className="pi pi-lock" /><h1>Reportes</h1><p>No tenés reportes habilitados para consultar.</p></main>;
  const { Componente } = reporteActual;

  return <main className="reportes-centro">
    <header className="reportes-centro-cabecera">
      <div><span>Centro de información</span><h1>Reportes</h1><p>Ventas, operación, inventario y administración en un único lugar.</p></div>
    </header>
    <nav className="reportes-tabs" aria-label="Categorías de reportes" ref={navegacionRef}>
      <div className="reportes-tabs-scroll">
        {categorias.map((categoria) => {
          const activa = reporteActual.categoriaId === categoria.id;
          const abierta = categoriaAbierta === categoria.id;
          return <div className={`reportes-tab${activa ? " activa" : ""}${abierta ? " abierta" : ""}`} key={categoria.id}>
            <button type="button" aria-expanded={abierta} aria-controls={`reportes-menu-${categoria.id}`} onClick={() => setCategoriaAbierta(abierta ? null : categoria.id)}>
              <i className={`pi ${categoria.icono}`} /><span>{categoria.nombre}</span><i className={`pi pi-chevron-${abierta ? "up" : "down"} reportes-tab-flecha`} />
            </button>
            {abierta && <div className="reportes-tab-menu" id={`reportes-menu-${categoria.id}`}>
              <span className="reportes-tab-menu-titulo">Reportes de {categoria.nombre}</span>
              {categoria.reportes.map((reporte) => {
                const seleccionado = activa && reporteActual.id === reporte.id;
                return <button type="button" key={reporte.id} className={seleccionado ? "seleccionado" : ""} aria-current={seleccionado ? "page" : undefined} onClick={() => { navigate(`/reportes/${categoria.id}/${reporte.id}`); setCategoriaAbierta(null); }}>
                  <i className={`pi ${reporte.icono}`} /><span><strong>{reporte.nombre}</strong><small>{reporte.descripcion}</small></span>{seleccionado && <i className="pi pi-check reportes-menu-check" />}
                </button>;
              })}
            </div>}
          </div>;
        })}
      </div>
      {mostrarAyudaNavegacion && <aside className="reportes-tabs-ayuda" role="note">
        <i className="pi pi-info-circle" /><span><strong>Navegación simplificada</strong> Elegí una categoría y luego el reporte.</span>
        <button type="button" aria-label="Ocultar ayuda de navegación" onClick={() => { sessionStorage.setItem("reportes-tabs-ayuda-oculta", "1"); setMostrarAyudaNavegacion(false); }}><i className="pi pi-times" /></button>
      </aside>}
    </nav>
    <label className="reportes-selector-movil"><span>Reporte</span><select value={`${reporteActual.categoriaId}/${reporteActual.id}`} onChange={(event) => navigate(`/reportes/${event.target.value}`)}>
      {categorias.map((categoria) => <optgroup key={categoria.id} label={categoria.nombre}>{categoria.reportes.map((reporte) => <option key={reporte.id} value={`${categoria.id}/${reporte.id}`}>{reporte.nombre}</option>)}</optgroup>)}
    </select></label>
    <section className="contenido-reportes" aria-label={reporteActual.nombre}><Componente {...(reporteActual.props || {})} /></section>
  </main>;
}
